import { useEffect, useState } from 'react';

const PRESET_DOMAINS = ['naver.com', 'gmail.com', 'daum.net', 'hanmail.net', 'kakao.com'];

/**
 * 이메일 입력 — [로컬]@[도메인 셀렉트 or 직접입력]
 * - value: full email string (controlled)
 * - onChange(string): full email 변경 emit
 */
export default function EmailDomainInput({ value = '', onChange, placeholder = 'example', className = '', inputClassName = '', disabled = false }) {
  const splitInitial = () => {
    const at = String(value).indexOf('@');
    if (at < 0) return { local: value || '', domain: 'naver.com', custom: false, customDomain: '' };
    const local = value.slice(0, at);
    const domain = value.slice(at + 1);
    if (PRESET_DOMAINS.includes(domain)) return { local, domain, custom: false, customDomain: '' };
    return { local, domain: 'custom', custom: true, customDomain: domain };
  };

  const [local, setLocal] = useState(() => splitInitial().local);
  const [domain, setDomain] = useState(() => splitInitial().domain);
  const [customDomain, setCustomDomain] = useState(() => splitInitial().customDomain);

  // 외부 value 변경 동기화 (form reset 등)
  useEffect(() => {
    const s = splitInitial();
    setLocal(s.local);
    setDomain(s.domain);
    setCustomDomain(s.customDomain);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const emit = (l, d, cd) => {
    const actualDomain = d === 'custom' ? cd : d;
    onChange?.(actualDomain ? `${l}@${actualDomain}` : l);
  };

  const baseInputCls = inputClassName || 'rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-indigo-500';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <input
        type="text"
        value={local}
        onChange={(e) => { setLocal(e.target.value); emit(e.target.value, domain, customDomain); }}
        placeholder={placeholder}
        disabled={disabled}
        className={`min-w-0 ${baseInputCls}`}
        style={{ width: '130px', flexGrow: 0, flexShrink: 0 }}
      />
      <span className="shrink-0 text-sm text-slate-500">@</span>
      {domain === 'custom' && (
        <input
          type="text"
          value={customDomain}
          onChange={(e) => { setCustomDomain(e.target.value); emit(local, 'custom', e.target.value); }}
          placeholder="domain.com"
          disabled={disabled}
          className={`min-w-0 flex-1 ${baseInputCls}`}
        />
      )}
      <select
        value={domain}
        onChange={(e) => { setDomain(e.target.value); emit(local, e.target.value, customDomain); }}
        disabled={disabled}
        className={`min-w-0 ${baseInputCls}`}
        style={{ flex: '1 1 0%' }}
      >
        {PRESET_DOMAINS.map((d) => <option key={d} value={d}>{d}</option>)}
        <option value="custom">직접입력</option>
      </select>
    </div>
  );
}
